<nz-space class="mobile-report-control">
  <app-stock-out-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="docCode">
  </app-stock-out-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-stock-out-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)"
    valueField="docCode"></app-stock-out-select>
</nz-space>